import React, { useState, useEffect } from "react";
import axios from "../../../api/axios";
import ComplaintsTable from "./components/ComplaintsTable";

const ComplaintsPage = () => {
  const [data, setData] = useState([]);
  const [statusFilter, setStatusFilter] = useState(""); // "", "Pending" | "Approved" | "Refused"

  useEffect(() => {
    const fetchComplaints = async () => {
      const token = "Bearer " + localStorage.getItem("token")?.replace(/"/g, "");
      try {
        //console.log("Admin -> sending adminStatus:", statusFilter || "(none)");
        const response = await axios.get("/api/complaints/all-complaints", {
          headers: { Authorization: token, "Content-Type": "application/json" },
          params: { adminStatus: statusFilter || undefined }
        });
        //console.log("Admin -> response:", response.data);
        setData(response.data);
      } catch (err) {
        console.error("Failed to fetch complaints:", err);
      }
    };
    fetchComplaints();
  }, [statusFilter]);

  return (
    <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
      <div className="mb-4 flex flex-wrap gap-2">
        <button onClick={() => setStatusFilter("")}
          className={`rounded px-3 py-2 ${statusFilter === "" ? "bg-brand-700 text-white" : "bg-gray-200"}`}>
          Të gjitha
        </button>
        <button onClick={() => setStatusFilter("Pending")}
          className={`rounded px-3 py-2 ${statusFilter === "Pending" ? "bg-brand-700 text-white" : "bg-gray-200"}`}>
          Në Pritje
        </button>
        <button onClick={() => setStatusFilter("Approved")}
          className={`rounded px-3 py-2 ${statusFilter === "Approved" ? "bg-brand-700 text-white" : "bg-gray-200"}`}>
          Aprovuar
        </button>
        <button onClick={() => setStatusFilter("Refused")}
          className={`rounded px-3 py-2 ${statusFilter === "Refused" ? "bg-brand-700 text-white" : "bg-gray-200"}`}>
          Refuzuar
        </button>
      </div>

     
      <ComplaintsTable tableData={data} statusField="adminStatus" />
    </div>
  );
};

export default ComplaintsPage;
